import { gql } from '@apollo/client';

export const CREATE_ACCOUNT = gql`
  mutation createAccount($input: CreateAccountInput!) {
    createAccount(input: $input) {
      account {
        id
        type
        applyForGovFunds
        householdClientGroup {
          id
          name
        }
        corporationClientGroup {
          id
          name
        }
        rightOfSurvivorship
        sourceOfFunds
        jurisdiction
        custodianAccountNumber
        user {
          firstName
          middleName
          lastName
        }
      }
    }
  }
`;

export const UPDATE_ACCOUNT_GROUP = gql`
  mutation updateAccountGroup($input: UpdateAccountGroupInput!) {
    updateAccountGroup(input: $input) {
      accountGroup {
        id
      }
    }
  }
`;
